import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card, Typography, Backdrop, Slide, Box, Portal } from "@mui/material";
import MDButton from "components/MDButton";
import Plan from "layouts/profile/components/Subscription/plan";

function FeatureUpgrade({
    open,
    onClose,
    featureName = "This feature",
    planRequired = "Higher Plan"
}) {
    const [showPlan, setShowPlan] = useState(false);

    // Reset internal state when the main popup closes
    React.useEffect(() => {
        if (!open) setShowPlan(false);
    }, [open]);

    return (
        <Portal>
            {/* 1. The small content popup (Message + Button) */}
            <Backdrop
                open={open && !showPlan}
                sx={{
                    zIndex: (t) => t.zIndex.modal + 30,
                    backgroundColor: "rgba(0,0,0,0.5)",
                    backdropFilter: "blur(4px)",
                }}
                onClick={onClose}
            >
                <Slide direction="up" in={open && !showPlan} mountOnEnter unmountOnExit>
                    <Card
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                            p: 4,
                            maxWidth: 460,
                            width: "90%",
                            borderRadius: "16px",
                            textAlign: "center",
                            backgroundColor: "rgba(255,255,255,0.95)",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
                        }}
                    >
                        <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
                            {featureName} is not available on your plan
                        </Typography>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Upgrade to <strong>{planRequired}</strong> to unlock this feature.
                        </Typography>

                        <MDButton
                            variant="contained"
                            color="accent"
                            size="medium"
                            onClick={() => setShowPlan(true)}
                            sx={{ px: 3, py: 1.2, fontWeight: 600, width: "auto", minWidth: "180px", alignSelf: "center" }}
                        >
                            UPGRADE PLAN
                        </MDButton>

                        <MDButton
                            variant="text"
                            color="secondary"
                            size="small"
                            onClick={onClose}
                            sx={{ mt: 2, display: 'block', mx: 'auto' }}
                        >
                            Cancel
                        </MDButton>
                    </Card>
                </Slide>
            </Backdrop>

            {/* 2. The full pricing table modal */}
            <Backdrop
                open={showPlan}
                sx={{
                    zIndex: (t) => t.zIndex.modal + 40,
                    backgroundColor: "rgba(0,0,0,0.8)",
                }}
            >
                <Slide direction="up" in={showPlan} mountOnEnter unmountOnExit>
                    <Card
                        sx={{
                            width: "95%",
                            maxWidth: "1100px",
                            maxHeight: "95vh",
                            overflowY: "auto",
                            p: 3,
                            backgroundColor: "white",
                            borderRadius: "16px",
                            position: "relative",
                        }}
                    >
                        <Box mt={3}>
                            <Plan onClose={() => { setShowPlan(false); onClose(); }} />
                        </Box>
                    </Card>
                </Slide>
            </Backdrop>
        </Portal>
    );
}

FeatureUpgrade.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    featureName: PropTypes.string,
    planRequired: PropTypes.string,
};

export default FeatureUpgrade;